import React from 'react';
import { ArrowRight, Download } from 'lucide-react';
import { mockCaseStudies } from '../data/mockData';

export default function CaseStudies() {
  return (
    <section id="case-studies" className="py-20 px-6 lg:px-[7.69%] bg-bg-panel border-b border-border-medium relative overflow-hidden">
      {/* Background Grid Pattern Overlay */}
      <div className="absolute inset-0 opacity-[0.06]" style={{
        backgroundImage: 'linear-gradient(rgba(255,255,255,0.4) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.4) 1px, transparent 1px)',
        backgroundSize: '60px 60px'
      }}></div>

      <div className="max-w-[1400px] mx-auto relative z-10">
        <div className="flex flex-col md:flex-row justify-between items-end mb-12 gap-6">
          <div>
            <span className="section-tag">/Proven Results</span>
            <h3 className="display-large">Case Studies</h3>
          </div>
          <button className="btn-secondary">View All Projects</button>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {mockCaseStudies.map((study) => (
            <div key={study.id} className="group relative bg-bg-primary border border-border-medium hover:border-brand-primary transition-colors duration-150">
              {/* Image Area */}
              <div className="aspect-video overflow-hidden relative">
                <div className="absolute inset-0 bg-black/20 group-hover:bg-transparent transition-all duration-500 z-10"></div>
                <img 
                  src={study.image} 
                  alt={study.title} 
                  className="w-full h-full object-cover filter grayscale group-hover:grayscale-0 transition-all duration-700 transform group-hover:scale-105" 
                />
                <div className="absolute top-3 left-3 z-20 px-2 py-0.5 bg-black/90 border border-brand-primary/60 text-brand-primary uppercase" style={{ fontSize: '9px', letterSpacing: '1.2px', fontWeight: 700 }}>
                  {study.category}
                </div>
              </div>

              {/* Content Area */}
              <div className="p-6">
                <h4 className="heading-3 mb-3 group-hover:text-brand-primary transition-colors">{study.title}</h4>
                <p className="body-medium mb-4 line-clamp-3">
                  {study.description}
                </p>

                {/* Stats Grid */}
                <div className="grid grid-cols-3 gap-2 mb-6 border-t border-border-medium pt-3">
                  {study.stats.map((stat, i) => (
                    <div key={i} className="text-text-primary" style={{ fontSize: '10px', letterSpacing: '0.5px' }}>
                      {stat}
                    </div>
                  ))}
                </div>

                <button className="flex items-center gap-2 text-brand-primary uppercase hover:underline decoration-brand-primary underline-offset-4" style={{ fontSize: '10px', fontWeight: 700, letterSpacing: '0.8px' }}>
                  <Download className="w-3.5 h-3.5" />
                  Download PDF
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
